/* 🤖 this file was generated by svg-to-ts */
export const iconLdo: {
  name: 'ldo';
  data: string;
} = {
  name: 'ldo',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g fill="currentColor" clip-path="url(#lido__clip0_297_32)"><path d="m19.9 13.034-3.89-6.086-3.9 6.086 3.9 2.268z"/><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.837 0 16 0m.01 4.68 5.614 8.764-5.614 3.264-5.614-3.263zm5.604 20.31c-3.1 3.09-8.128 3.09-11.228 0a7.91 7.91 0 0 1-1.077-9.862l.174-.277 6.507 3.787 6.507-3.788.174.278a7.91 7.91 0 0 1-1.078 9.862z"/></g><defs><clipPath id="lido__clip0_297_32"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
